/* jshint esversion:6 */
import Cons from '@/constants.json'
import * as API from '@/endpoints'
import VueCookie from 'vue-cookie'
import Axios from 'axios'
import Vue from 'vue'
import router from '@/router'
import { Spin } from 'iview'
import _ from "lodash"

export default {
  namespaced: true,
  state: {
    fields: {},
    org: {
      isLoading: false
    },
    organization: {
      info: {}, //refers to the careplan
      brand: {}, //refers to organization brand
      careplan_id: "",
      isLoading: false,
      isLoadingMore: false,
      data: {}
    },
    organizations: {
      isLoading: false,
      isLoadingMore: false,
      data: {},
      nearby: {},
      isLoadingFeatured: false,
      isLoadingMoreFeatured: false,
      featuredData: {},
      all: {
        data: [],
        nextPage: null,
        isLoadingNext: false
      }
    }
  },
  getters: {
    getAllOrganizations: state => state.organizations.all.data,
    hasNextOrganization: state => state.organizations.all.nextPage != null,
    isLoadingNextOrganization: state => state.organizations.all.isLoadingNext,
    allNextPageUrl: state => state.organizations.all.nextPage,
    getAllNearbyOrganizations: state => _.get(state.organizations.nearby, "items", [])
  },
  mutations: {
    setAllOrganizations(state, v) {
      state.organizations.all.data = v.concat ? state.organizations.all.data.concat(v.doctors) : v.doctors
      state.organizations.all.nextPage = v.next_link
    },
    setLoadingAllNextOrganization(state, v) {
      state.organizations.all.isLoadingNext = v
    },
    setFeaturedOrganizations(state, v) {
      Vue.set(state.organizations, "featuredData", v)
    },
    setFeaturedOrganizationsLoader(state, v) {
      state.organizations.isLoadingFeatured = v
    },
    setFeaturedOrganizationsLoadMore(state, v) {
      state.organizations.isLoadingMoreFeatured = v
    },
    setOrganizations(state, v) {
      state.organizations.data = v
    },
    setOrganizationsLoader(state, v) {
      state.organizations.isLoading = v
    },
    setOrganizationsLoadMore(state, v) {
      state.organizations.isLoadMore = v
    },
    setNearbyOrganizations(state, v) {
      state.organizations.nearby = v
    },
    setOrganizationField(state, v) {
      state.fields = v;
    },
    setOrganizationLoader(state, v) {
      state.org.isLoading = v;
    },
    setOrganizationItemLoading(state, v) {
      state.organization.isLoading = v
    },
    setOrganizationItemLoadingMore(state, v) {
      state.organization.isLoadingMore = v
    },
    setOrganizationCareplanId(state, v) {
      state.organization.careplan_id = v
    },
    setOrganizationItems(state, v) {
      state.organization.data.careplan_item = v
    },
    setOrganizationData(state, v) {
      state.organization.data = v
    },
    setOrganizationInfo(state, v) {
      state.organization.info = v
    },
    setOrganizationBrand(state, v) {
      state.organization.brand = v
    },
    pushItemToOrganizationFeed(state, payload) {
      if (state.organization.data.careplan_item)
      state.organization.data.careplan_item.push(payload)
    },
    clearOrganization(state) {
      state.organization = {
        info: {}, //refers to the careplan
        brand: {}, //refers to organization brand
        careplan_id: "",
        isLoading: false,
        isLoadingMore: false,
        data: {}
      }
    }
  },
  actions: {
    addToCareteam({commit, dispatch, state}, brand_id){
      return new Promise((resolve, reject) => {
        Axios.post(`${API.endpoints.mainbrand}/careteam/${brand_id}`)
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    removeFromCareteam({commit, dispatch, state}, journal_careplan_id){
      return new Promise((resolve, reject) => {
        Axios.delete(`${API.endpoints.careplan}/${journal_careplan_id}/remove`)
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    removeBookmark({commit, dispatch, state}, id) {
      return new Promise((resolve, reject) => {
        Axios.delete(`${API.endpoints.bookmark}/${id}`)
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    bookmark({commit, dispatch, state}, id) {
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.bookmark, {
          item_id: id,
          type: 'brand'
        })
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    getFeaturedOrganizations({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        commit('setFeaturedOrganizationsLoader', true)
        Axios.get(`${API.endpoints.base}all/brands`, {
          params: {
            all: 1,
            featured_only:1,
            type: "organization",
            include_hidden: 0,
            app_id: Cons[0].BRAND_ID,
            brand_id: Cons[0].BRAND_ID,
            per_page: 30
          }
        })
          .then(res => {
            console.log("loaded")
            commit('setFeaturedOrganizations', res.data)
            commit('setFeaturedOrganizationsLoader', false)
            resolve(res.data)
          })
          .catch(err => {
            commit('setFeaturedOrganizationsLoader', false)
            reject(err)
          })
      })
    },
    getAllOrganizations({ commit }) {
      Axios.get(`${API.endpoints.base}all/brands`, {
        params: {
          all: 1,
          type: "organization",
          app_id: Cons[0].BRAND_ID,
          brand_id: Cons[0].BRAND_ID,
          include_hidden: 0
        }
      })
        .then(res => {
          commit("setAllOrganizations", res.data)
          Promise.resolve(res.data)
        })
        .catch(err => {
          Promise.reject(err)
        })
    },
    getNextAllOrganizations({ commit }, url) {
      commit("setLoadingAllNextOrganization", true)
      Axios.get(url)
          .then(res => {
            commit("setAllOrganizations", {...res.data, concat: true})
            Promise.resolve(res.data)
          })
          .catch(err => {
            Promise.reject(err)
          })
          .finally(() => commit("setLoadingAllNextOrganization", false));
    },
    getMostOrganizations({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        Axios.get(`${API.endpoints.base}all/brands?order_by_most_followed=1&per_page=10&type=organization`)
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    getNearbyOrganizations({ commit, dispatch, state }, zipcode) {
      // order_by_most_followed=1
      return new Promise((resolve, reject) => {
        commit('setOrganizationsLoader', true)
        // let params = {
        //   type: "organization",
        //   include_hidden: 0,
        //   app_id: Cons[0].BRAND_ID,
        //   brand_id: Cons[0].BRAND_ID
        // }

        // if (zipcode) {
        //   params.zipcode = zipcode
        //   params.radius = 2000
        // }

        Axios.get(`${API.endpoints.base}nearby-organizations`, {
          params: {
            zipcode: zipcode,
            radius: 2000
          }
        })
          .then(res => {
            commit('setOrganizationsLoader', false)
            commit('setNearbyOrganizations', res.data)
            resolve(res.data)
          })
          .catch(err => {
            commit('setOrganizationsLoader', false)
            reject(err)
          })
      })
    },
    getMoreOrganizationItems({ commit, dispatch, state }, url) {
      commit('setOrganizationItemLoadingMore', true)
      return new Promise((resolve, reject) => {
        Axios.get(url)
          .then(res => {
            commit('setOrganizationItemLoadingMore', false)
            var currentItems = state.organization.data.careplan_item
            commit('setOrganizationData', res.data)
            currentItems.push(res.data.careplan_item)
            commit('setOrganizationItems', currentItems)
            resolve(res.data.careplan_item)
          })
          .catch(err => {
            commit('setOrganizationItemLoadingMore', false)
            reject(err)
          })
      })
    },
    getOrganizationGallery({ commit, dispatch, state }) {
      commit('setOrganizationItemLoading', true)
      return new Promise((resolve, reject) => {
        Axios.get(`${API.endpoints.careplan}/${state.organization.careplan_id}/item?type=gallery`)
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    getOrganizationItems({ commit, dispatch, state }) {
      commit('setOrganizationItemLoading', true)
      return new Promise((resolve, reject) => {
        Axios.get(`${API.endpoints.careplan}/${state.organization.careplan_id}/item`)
          .then(res => {
            commit('setOrganizationItemLoading', false)
            commit('setOrganizationData', res.data)
            resolve(res.data)
          })
          .catch(err => {
            commit('setOrganizationItemLoading', false)
            reject(err)
          })
      })
    },
    getOrganizationBrand({ commit, dispatch }, brandId) {
      return new Promise((resolve, reject) => {
        Axios.get(`${API.endpoints.brand}/${brandId}`)
          .then(res => {
            commit('setOrganizationBrand', res.data)
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    getOrganizationInfo({ commit, dispatch }, orgId) {
      return new Promise((resolve, reject) => {
        Axios.get(`${API.endpoints.careplan}/${orgId}`)
          .then(res => {
            commit('setOrganizationCareplanId', orgId)
            commit('setOrganizationInfo', res.data)
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    createdBrand({ commit, dispatch, state }, { data, avatar }) {
      return new Promise((resolve, reject) => {

        let allianceData = {
          title: data.display_name,
          type: 'alliance',
          developed_by: "1",
          duration: 0,
          duration_unit: "day",
          thumbnail_photo: avatar || null,
          section: "group",
          access: "public",
          data
        }

        if (data.background) {
          allianceData.pages = [{
            title: "Background",
            activity_name: "Tip of the day",
            data_type: "content",
            type: 'statement',
            order: 1,
            day: -1,
            data: {
              tip: data.background
            }
          }]
        }

        commit('setOrganizationLoader', true);
        Axios.post(API.endpoints.careplan, allianceData)
          .then((res) => {
            commit('setOrganizationLoader', false);
            resolve(res.data);
          })
          .catch(_err => {
            commit('setOrganizationLoader', false);
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(_err)
          });
      })
    },
    getOrganizationFields({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.base + 'profile/fields?object_type=group')
          .then((res) => {
            commit('setOrganizationField', res.data);
            resolve(res.data);
          })
          .catch(_err => {
            dispatch('exceptionHandling', { _err: _err }, { root: 1 })
            reject(_err)
          });
      })
    }
  }
}
